import styled from "styled-components"

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.6rem;
  font-size: 1.6rem;
  margin: 2rem;
  padding: 2rem;

  svg {
    margin-right: 2rem;
    height: 2rem;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  div {
    display: flex;
    align-items: center;
  }
`

export const OperationsContainer = styled.div`
  justify-content: space-between;
  border-top: 0.1rem solid ${({ theme }) => theme.colors.borderLight};
  margin-top: 2rem;
  padding-top: 1rem;
  font-size: 1.4rem;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    display: flex;
  }

`

export const Id = styled.div`
  font-size: 1.2rem;
  color: ${(props) => props.theme.colors.greyDark};
  text-decoration: underline;
  cursor: pointer;

  a {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.greyDark};
  }
`

export const Reason = styled.div`
  font-size: 1.4rem;
  color: ${(props) => props.theme.colors.greyDark};
`

export const OrderLineInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 28rem;
  font-size: 1.4rem;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    width: 35rem;
  }
`
